import { cardTypes, PaymentCardTypeConfig } from './cardTypes';

export const getPaymentCardTypeConfigFromNumber = (number: string): PaymentCardTypeConfig | undefined => {
    const sanitizedNumber = number.replace(/\D/g, '');
    return cardTypes.find((type) => type.pattern.test(sanitizedNumber));
};
